module.exports = __webpack_public_path__ + "img/0569589.jpg";